// const home = () => import(/* webpackChunkName: "dashboard" */ '../views/home/home.vue')

export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    meta: {
      name: '数据概况',
      keepAlive: true
    },
    // component: home
  }
]
